// Mock data for WorldVibe - replace with real backend data later

export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_0e4e1de3-c8bd-4f91-86eb-22033eafb01a/artifacts/9z7e1fb1_WorldVibe%20Brand%20Guidelines.docx';
// Use uploaded WorldVibe logo asset
export const APP_LOGO = '/logo.jpeg';

// Cosmic Ranks are XP-driven (NOT Stars). XP is earned via chat, daily login,
// mini-games, missions, and community engagement — never purchased.
// Mirrors the source of truth in /app/backend/deps.py COSMIC_RANKS.
export const COSMIC_RANKS = [
  { rank: 1, name: 'Explorer', xp: 0, benefits: ['Basic profile', 'Join up to 5 Planets', '1 Pet slot', 'Standard daily reward'], color: '#A8A8B3' },
  { rank: 2, name: 'Traveler', xp: 1000, benefits: ['Traveler badge', 'Join up to 10 Planets', 'Increased daily reward'], color: '#7DD3FC' },
  { rank: 3, name: 'Voyager', xp: 5000, benefits: ['Voyager profile frame', 'Join up to 20 Planets', '2 Pet slots', 'Increased daily reward'], color: '#00C6FF' },
  { rank: 4, name: 'Astronaut', xp: 15000, benefits: ['Astronaut badge', 'Create your first Planet', 'Unlimited dating discovery', '3 Pet slots', 'Enhanced daily rewards'], color: '#00F5D4' },
  { rank: 5, name: 'Cosmonaut', xp: 35000, benefits: ['Exclusive profile frame', 'Increased friend limit', 'Enhanced daily rewards'], color: '#34D399' },
  { rank: 6, name: 'Star Commander', xp: 75000, benefits: ['Custom profile banner', 'Exclusive profile customization'], color: '#FBBF24' },
  { rank: 7, name: 'Galactic Guardian', xp: 150000, benefits: ['Colored username in chat', 'Create up to 3 Planets', 'Premium profile effects'], color: '#FB923C' },
  { rank: 8, name: 'Nebula Master', xp: 300000, benefits: ['Exclusive cosmic effects', 'Rare profile cosmetics'], color: '#F472B6' },
  { rank: 9, name: 'Celestial Titan', xp: 600000, benefits: ['Rare pet unlocks', 'Premium profile customizations'], color: '#C084FC' },
  { rank: 10, name: 'Cosmic Sovereign', xp: 1200000, benefits: ['Elite profile appearance', 'Exclusive banner styles'], color: '#A78BFA' },
  { rank: 11, name: 'Universal Architect', xp: 2500000, benefits: ['Legendary profile aura', 'Exclusive rank cosmetics'], color: '#7B2FF7' },
  { rank: 12, name: 'Supreme Being', xp: 5000000, benefits: ['Animated cosmic aura', 'Hall of Fame profile badge', 'Exclusive annual cosmetic rewards', 'Highest prestige status'], color: '#F0ABFC' },
];

export const HIDDEN_RANK = {
  name: 'The Creator',
  status: 'Legendary',
  description: 'Invite Only. Awarded by WorldVibe Administration to Founders, Exceptional Contributors and Global Event Champions.',
};

// Dicebear avatars (free, no key)
const dice = (seed, style = 'avataaars') => `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(seed)}`;

export const CURRENT_USER = {
  id: 'u_me',
  username: 'AuroraNova',
  displayName: 'Aurora Nova',
  avatar: dice('AuroraNova', 'adventurer'),
  bio: 'Wandering the cosmos, one chat at a time. ',
  country: 'India',
  flag: '\uD83C\uDDEE\uD83C\uDDF3',
  stars: 48230,
  xp: 12450,
  credits: 2840,
  rank: 5,
  followers: 1284,
  following: 312,
  giftsReceived: 89,
  planetsJoined: 14,
  banner: 'linear-gradient(135deg, #7B2FF7 0%, #00C6FF 50%, #00F5D4 100%)',
};

export const PLANETS = [
  { id: 'p1', name: 'Aurora Lounge', creator: 'NebulaQueen', members: 12480, online: 248, theme: 'chill', color: 'from-fuchsia-500 to-purple-600', emoji: '\uD83C\uDF0C', description: 'Chill vibes, deep talks, and northern-light energy.', tags: ['Chill','Music','Philosophy'] },
  { id: 'p2', name: 'Mars Colony', creator: 'RedRover', members: 8920, online: 412, theme: 'gaming', color: 'from-orange-500 to-red-600', emoji: '\uD83D\uDE80', description: 'Strategy. Sci-fi. Survival. Welcome to the red planet.', tags: ['Gaming','Sci-Fi','Strategy'] },
  { id: 'p3', name: 'Neon Tokyo', creator: 'CyberSakura', members: 21340, online: 980, theme: 'culture', color: 'from-pink-500 to-rose-600', emoji: '\uD83C\uDF38', description: 'Anime, J-pop, street fashion and midnight ramen.', tags: ['Anime','Culture','Music'] },
  { id: 'p4', name: 'Code Galaxy', creator: 'ByteWizard', members: 5630, online: 187, theme: 'tech', color: 'from-cyan-500 to-blue-600', emoji: '\uD83D\uDC68\u200D\uD83D\uDCBB', description: 'Developers helping developers. Ship code, ship friends.', tags: ['Tech','Coding','AI'] },
  { id: 'p5', name: 'Lover\'s Nebula', creator: 'StarCrossed', members: 17890, online: 642, theme: 'dating', color: 'from-rose-500 to-pink-600', emoji: '\uD83D\uDC96', description: 'Meet someone written in the stars.', tags: ['Dating','Romance','Talk'] },
  { id: 'p6', name: 'Cosmic Beats', creator: 'DJOrbit', members: 9450, online: 320, theme: 'music', color: 'from-violet-500 to-indigo-600', emoji: '\uD83C\uDFB6', description: 'Live DJ rooms. Discover artists across the galaxy.', tags: ['Music','DJ','Live'] },
  { id: 'p7', name: 'Foodie Universe', creator: 'ChefAstra', members: 6780, online: 154, theme: 'food', color: 'from-amber-500 to-orange-600', emoji: '\uD83C\uDF55', description: 'Recipes, restaurants and food adventures worldwide.', tags: ['Food','Travel','Lifestyle'] },
  { id: 'p8', name: 'Stargazers', creator: 'CelestialEye', members: 4210, online: 98, theme: 'space', color: 'from-blue-600 to-indigo-700', emoji: '\uD83D\uDD2D', description: 'Astronomy, telescopes, and the wonder above.', tags: ['Space','Science','Photography'] },
];

const names = ['LunaWolf','NovaStar','CometX','OrbitKing','GalaxyMuse','SolarFlare','NebulaQueen','VoidWalker','PixelPilot','EchoRider','NeonFox','PhantomX','AstroLily','CyberSakura','RedRover','ByteWizard','DJOrbit','StarCrossed','ChefAstra','CelestialEye'];

export const ONLINE_USERS = names.map((n, i) => ({
  id: 'u_' + i,
  username: n,
  avatar: dice(n, i % 2 ? 'adventurer' : 'avataaars'),
  rank: 1 + (i % 12),
  status: ['Online','Away','In Chat','Idle'][i % 4],
  country: ['IN','US','JP','BR','DE','FR','UK','KR','MX','EG'][i % 10],
}));

export const CHAT_MESSAGES = {
  p1: [
    { id: 1, user: 'NebulaQueen', avatar: dice('NebulaQueen'), text: 'Welcome travelers \u2728 grab a seat, the aurora is starting.', time: '14:02', rank: 9 },
    { id: 2, user: 'LunaWolf', avatar: dice('LunaWolf'), text: 'First time here, this music is unreal', time: '14:03', rank: 3 },
    { id: 3, user: 'NovaStar', avatar: dice('NovaStar'), text: 'Anyone from Tokyo? I\u2019m heading there next week', time: '14:05', rank: 5 },
    { id: 4, user: 'OrbitKing', avatar: dice('OrbitKing'), text: 'Bro check Neon Tokyo planet, you\u2019ll love it', time: '14:06', rank: 7 },
    { id: 5, user: 'CometX', avatar: dice('CometX'), text: 'gifted \uD83C\uDF1F Star Cluster to NebulaQueen', time: '14:08', rank: 6, isGift: true },
    { id: 6, user: 'AstroLily', avatar: dice('AstroLily'), text: 'lol this room is wholesome \uD83D\uDC96', time: '14:09', rank: 4 },
    { id: 7, user: 'EchoRider', avatar: dice('EchoRider'), text: 'Drop your top 3 lo-fi tracks RIGHT NOW', time: '14:11', rank: 5 },
  ],
  p2: [
    { id: 1, user: 'RedRover', avatar: dice('RedRover'), text: 'Mission briefing at 22:00 UTC \uD83D\uDEF8', time: '13:50', rank: 10 },
    { id: 2, user: 'PhantomX', avatar: dice('PhantomX'), text: 'I\u2019m in. need a sniper class teammate', time: '13:52', rank: 6 },
  ],
};

export const GIFTS = [
  { id: 'g1', name: 'Single Rose', emoji: '\uD83C\uDF39', price: 10, rarity: 'common' },
  { id: 'g2', name: 'Heart Cluster', emoji: '\u2764\uFE0F', price: 50, rarity: 'common' },
  { id: 'g3', name: 'Crown', emoji: '\uD83D\uDC51', price: 200, rarity: 'rare' },
  { id: 'g4', name: 'Diamond', emoji: '\uD83D\uDC8E', price: 500, rarity: 'rare' },
  { id: 'g5', name: 'Sports Car', emoji: '\uD83C\uDFCE\uFE0F', price: 1500, rarity: 'epic' },
  { id: 'g6', name: 'Yacht', emoji: '\uD83D\uDEA4', price: 5000, rarity: 'epic' },
  { id: 'g7', name: 'Private Jet', emoji: '\u2708\uFE0F', price: 12000, rarity: 'legendary' },
  { id: 'g8', name: 'Castle', emoji: '\uD83C\uDFF0', price: 25000, rarity: 'legendary' },
  { id: 'g9', name: 'Galaxy', emoji: '\uD83C\uDF0C', price: 50000, rarity: 'mythic' },
  { id: 'g10', name: 'Rocket', emoji: '\uD83D\uDE80', price: 800, rarity: 'rare' },
  { id: 'g11', name: 'Teddy Bear', emoji: '\uD83E\uDDF8', price: 75, rarity: 'common' },
  { id: 'g12', name: 'Cake', emoji: '\uD83C\uDF82', price: 120, rarity: 'common' },
];

export const GAMES = [
  { id: 'gm1', name: 'Cosmic Roulette', emoji: '\uD83C\uDFAF', players: 1240, reward: 'Up to 10,000 Stars', color: 'from-fuchsia-500 to-purple-600' },
  { id: 'gm2', name: 'Star Crash', emoji: '\uD83D\uDCA5', players: 890, reward: 'Up to 5,000 Stars', color: 'from-orange-500 to-rose-500' },
  { id: 'gm3', name: 'Planet Trivia', emoji: '\uD83E\uDDE0', players: 540, reward: 'Up to 2,500 Stars', color: 'from-cyan-500 to-blue-600' },
  { id: 'gm4', name: 'Lucky Lottery', emoji: '\uD83C\uDF9F\uFE0F', players: 2100, reward: 'Jackpot 100,000', color: 'from-amber-500 to-yellow-500' },
  { id: 'gm5', name: 'Galaxy Race', emoji: '\uD83C\uDFC1', players: 320, reward: 'Up to 8,000 Stars', color: 'from-emerald-500 to-teal-600' },
  { id: 'gm6', name: 'Cosmic Pets', emoji: '\uD83D\uDC09', players: 1800, reward: 'Rare Pets', color: 'from-pink-500 to-rose-600' },
];

export const NOTIFICATIONS = [
  { id: 1, type: 'gift', text: 'NebulaQueen sent you a \uD83D\uDC8E Diamond', time: '2m ago' },
  { id: 2, type: 'follow', text: 'OrbitKing started following you', time: '15m ago' },
  { id: 3, type: 'rank', text: 'You\u2019re 5,200 stars away from Star Commander!', time: '1h ago' },
  { id: 4, type: 'planet', text: 'New event on Mars Colony: \u201cInvasion Night\u201d', time: '3h ago' },
];

export const DIRECT_MESSAGES = [
  { id: 'dm1', user: 'NebulaQueen', avatar: dice('NebulaQueen'), last: 'see you on Aurora tonight \u2728', time: '14:02', unread: 2, rank: 9 },
  { id: 'dm2', user: 'OrbitKing', avatar: dice('OrbitKing'), last: 'thanks for the gift! \uD83D\uDE4F', time: '12:30', unread: 0, rank: 7 },
  { id: 'dm3', user: 'CyberSakura', avatar: dice('CyberSakura'), last: 'recommend me a planet?', time: 'Yesterday', unread: 1, rank: 6 },
  { id: 'dm4', user: 'ChefAstra', avatar: dice('ChefAstra'), last: 'sending recipe in 5', time: 'Mon', unread: 0, rank: 4 },
];

export const STATS = {
  travelers: '12.4M',
  planets: '84,210',
  messagesPerDay: '38M',
  countries: '193',
};
